module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-07 at 19.48.21.9c3bf1ef.jpeg";